// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c236b0ab","455":"dc737e83","577":"26ac71f2","851":"193c003f"}[chunkId] + ".chunk.js";
};